import Styles from './UserStreams.module.scss';
// Rect imports
import { useState } from 'react';
import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
// Components Imports
import { useAPI, Message, AuthContext } from 'components/lib';
import GridViewCard from 'components/global/GridViewCard/GridViewCard';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { PaymentPending } from 'views/account/paymentPending';
// Material icon import
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';
// Other imports
import axios from 'axios';
import { StyledBadge } from 'components/badge/badge';

export function UserStreams(props) {
	const navigate = useNavigate();
	const context = useContext(AuthContext)

	// Helper function to get the index of a array in streamList from id
	function findDictionaryIndex(array, key, value) {
		for (let index = 0; index < array.length; index++) {
			const dictionary = array[index];
			if (dictionary.hasOwnProperty(key) && dictionary[key] === value) {
				return index;
			}
		}
		return -1; // Return -1 if the dictionary is not found
	}

	const [streamList, setStreamList] = useState([]);
	const { data, loading: streamsLoading } = useAPI(`/api/user/streams`, 'GET');

	useEffect(() => {
		if (data?.length) {
			setStreamList(data)
		}
	}, [data]);

	// redirect to challenge page
	const handleClick = (data) => {
		const id = data.id;
		const index = findDictionaryIndex(streamList, "id", `${id}`);
		const streamStatus = streamList[index].status
		const options = {
			method: "POST",
			url: `/api/user/streams/${id}/assign`,
			headers: {
				"accept": "application/json",
			},
		};
		if (streamStatus === "Not Started") {
			axios
				.request(options)
				.then(async function (response) {
					await new Promise((resolve) => setTimeout(resolve, 50)); // Adding a wait for api post to happen
					navigate(`/streams/${id}/challenges`);
				})
				.catch((err) => {
					let status = err.response.status;
					console.log("error", status);
					navigate('/oops');
				});
		} else {
			navigate(`/streams/${id}/challenges`);
		}
	};

	function handleEnrollClick() {
		navigate(`/streams/all`)
	}

	return (
		<>
			{context.user.subscription === 'active' ? (
				context?.user?.onboarded ? (
					<Message
						closable
						title={props.t('Streams.UserStreams.info.title')}
						text={props.t('Streams.UserStreams.info.text')}
						type="info"
					/>
				) : (
					<Message
						title={props.t('Streams.UserStreams.profile_pending.title')}
						text={props.t('Streams.UserStreams.profile_pending.text')}
						type="warning"
						buttonText={props.t('Streams.UserStreams.profile_pending.buttonText')}
						buttonLink={'/account'}
					/>
				)
			) : (
				<PaymentPending />
			)}
			<div className={Styles.CardContainer}>
				<div className={Styles.tabContainer}>
					<BreadCrumbs
						onClickPaths={[
							'/streams/all', ''
						]}
						crumbs={
							props.t('Streams.UserStreams.breadcrumbs', { returnObjects: true })
						}
					/>

					{!(context?.user?.plan === 'free' || context?.user.plan === 'hybrid') ?
						<button
							variant="extended"
							className={Styles.enrollButton}
							onClick={() => { handleEnrollClick(); }}
						>
							<AddCircleOutlineTwoToneIcon />
							{props.t('Streams.UserStreams.enrollButton')}	</button> :
						<button
							variant="extended"
							className={Styles.enrollButton}
							onClick={() => {
								navigate('/streams/purchase')
							}}
						>
							<AddCircleOutlineTwoToneIcon />
							{props.t('Streams.UserStreams.purchaseButton')}	</button>
					}
				</div>

				<>
					<div id='parentContainer'
						style={{
							flexWrap: 'wrap',
							alignItems: streamsLoading === "Loading" & streamList.length > 0 ? 'center' : 'none'
						}}>
						{streamsLoading ? (
							<div>
								<LoadingBackdrop isOpen={true} />
							</div>
						) : streamList.length > 0 ? (
							<div style={{ display: 'flex', flexWrap: 'wrap' }}>
								{streamList.map((stream) => {
									return (
										<StyledBadge badgeContent={stream.is_new ? "new" : 0} color="primary">
											<GridViewCard
												data={stream}
												key={stream.id}
												onClick={handleClick}
												button_text={stream.buttonText}
												showProgressBar={true}
												showInfoChips={true}
												expiredRedirection={`/streams/purchase`}
												tooltipMessage={props.t('Streams.UserStreams.tooltip')}
											/>
										</StyledBadge>
									);
								})}

							</div>
						) : (
							<div id='enrollContainer' className={Styles.enrollContainer}>
								<div className={Styles.contentContainer}>
									{!(context?.user?.plan === 'free' || context?.user.plan === 'hybrid') ? (
										<>
											<p>{props.t('Streams.UserStreams.message.user.enroll')}</p>
											<p>{props.t('Streams.UserStreams.message.direction.enroll')}</p>
										</>
									) : (
										<>
											<p>{props.t('Streams.UserStreams.message.user.purchase')}</p>
											<p>{props.t('Streams.UserStreams.message.direction.purchase')}</p>
										</>
									)}
								</div>
							</div>
						)}
					</div>
				</>
			</div>
		</>
	);
}
